/**
 * @fileoverview GET handler for the "/apps/:app_group_id/charts/has_revenue" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appsAppGroupIdChartsHasRevenue } from "./constants";
import type { AppGroupHasRevenueResult } from "./types";

export const getAppGroupHasRevenue = reactQueryFetcherAdapter(
  appsAppGroupIdChartsHasRevenue,
  (signal: AbortSignal, appGroupId: string): Promise<AppGroupHasRevenueResult> => {
    return fetch(`/apps/${appGroupId}/charts/has_revenue`, "GET", {}, { signal });
  }
);
